import styled from 'styled-components';

export const MainContainer = styled.div`
  & > div:first-child {
    margin-bottom: 16px;
  }
`;

export const FormWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 288px);
  column-gap: 48px;
  row-gap: 0;
`;
